import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 910DF87E-809E-40D6-886F-34E581899455
 * name alpha-b
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-b.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaBIcon = createSvgIcon(<><path d="M15,10.5V9A2,2 0 0,0 13,7H9V17H13A2,2 0 0,0 15,15V13.5C15,12.7 14.3,12 13.5,12C14.3,12 15,11.3 15,10.5M13,15H11V13H13V15M13,11H11V9H13V11Z" /></>, 'AlphaBIcon');
export default AlphaBIcon